import HPagination from "./src/index.vue";
export default HPagination;